import { Theme } from '../theme.types'
import { BaseColor, ColorShade, repairPalette } from '../palette'
import baseTheme from './sharedBase'
import { darkAbsoluteColors, darkStatusPalettes } from './sharedColors'

const unboundedDarkTheme: Theme = {
  ...baseTheme,
  palette: repairPalette({
    absolute: darkAbsoluteColors,
    ...darkStatusPalettes,

    base: {
      [BaseColor.min]: '#000000',
      [BaseColor.shade_0]: '#050918',
      [BaseColor.shade_10]: '#111525',
      [BaseColor.shade_20]: '#1E212D',
      [BaseColor.shade_30]: '#373A46',
      [BaseColor.shade_40]: '#585863',
      [BaseColor.shade_50]: '#73737C',
      [BaseColor.shade_60]: '#A5A5AD',
      [BaseColor.shade_70]: '#CACAD2',
      [BaseColor.shade_80]: '#DFDFE5',
      [BaseColor.shade_90]: '#EFEFF2',
      [BaseColor.shade_100]: '#FAFAFA',
      [BaseColor.max]: '#FFFFFF',
      [BaseColor.surfaceBg]: '#111525',
      [BaseColor.overlay]: '#050918',
    },

    primary: {
      [ColorShade.foreground]: '#FFFFFF',
      [ColorShade.softest]: '#102B40',
      [ColorShade.softer]: '#244F70',
      [ColorShade.soft]: '#2D6FA0',
      [ColorShade.semiSoft]: '#378ECF',
      [ColorShade.color]: '#40ADFF',
      [ColorShade.semiStrong]: '#70C2FF',
      [ColorShade.strong]: '#A0D6FF',
      [ColorShade.stronger]: '#CFEBFF',
      [ColorShade.strongest]: '#ECF7FF',
    },
  }),
}

export default unboundedDarkTheme
